/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-08 10:03:10
 *
 *******************************************************/

import IconFilter from 'src/assets/images/quick-start-guide/icon.filter.svg';
import IconSearch from 'src/assets/images/quick-start-guide/icon.search.svg';
import IconRecommend from 'src/assets/images/quick-start-guide/icon.recommend.svg';
import IconPreview from 'src/assets/images/quick-start-guide/icon.preview.svg';
import ImgFilter1 from 'src/assets/images/quick-start-guide/img.filter1.svg';
import ImgFilter2 from 'src/assets/images/quick-start-guide/img.filter2.svg';
import ImgFilter3 from 'src/assets/images/quick-start-guide/img.filter3.svg';
import ImgFilter4Advanced from 'src/assets/images/quick-start-guide/img.filter4.advanced.svg';
import ImgFilter5Advanced from 'src/assets/images/quick-start-guide/img.filter5.advanced.svg';
import ImgSearch1 from 'src/assets/images/quick-start-guide/img.search1.svg';
import ImgSearch2 from 'src/assets/images/quick-start-guide/img.search2.svg';
import ImgRecommend1 from 'src/assets/images/quick-start-guide/img.recommend1.svg';
import ImgRecommend2 from 'src/assets/images/quick-start-guide/img.recommend2.svg';
import ImgPreview1 from 'src/assets/images/quick-start-guide/img.preview1.svg';
import ImgPreview2 from 'src/assets/images/quick-start-guide/img.preview2.svg';
import ImgPreview3 from 'src/assets/images/quick-start-guide/img.preview3.svg';

export const DASHBOARD_LAYOUT_FIRST_COLUMN = [
  ['notifications'],
  ['quickStartGuide'],
  ['crossSellUpSell'],
  ['subscriptionStatus', 'themeSetupStatus'],
  ['getSupport'],
  ['optionInEmail']
];

export const DASHBOARD_LAYOUT_SECOND_COLUMN = [
  ['syncHookStatus'],
  ['changeLogs'],
  ['recommendedApps']
];

export const DASHBOARD_BLOCKS_DEFAULT = {
  themeSetupStatus: true,
  menuDashboard1: true,
  syncHookStatus: true,
  gettingStartedVideos: true,
  guideToKnowledgeBase: true,
  helpCenter: true,
  subscriptionStatus: true,
  onboardingChecklist: true,
  welcomeOnboarding: true,
  feedback: true
};

export const MIN_PLAN_PRICE = 900;
export const MIN_TOTAL_VALUE_OF_PLANS = 990;

/**
 * Defined all guide, step guide
 */
export const DATA_GUIDE_V2 = [
  {
    title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter_title',
    icon: IconFilter,
    keyGuide: 'V2_FILTER',
    feature: 'Filter',
    children: [
      {
        title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter1_label',
        description: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter1_description',
        btnTexts: ['AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter1_btn'],
        img: ImgFilter1,
        keyStep: 'V2_FILTER1'
      },
      {
        title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter2_label',
        description: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter2_description',
        btnTexts: ['AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter2_btn'],
        img: ImgFilter2,
        keyStep: 'V2_FILTER2'
      },
      {
        title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter3_label',
        description: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter3_description',
        btnTexts: ['AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter3_btn'],
        img: ImgFilter3,
        keyStep: 'V2_FILTER3'
      }
    ],
    childrenAdvanced: [
      {
        title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter4Advanced_label',
        description: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter4Advanced_description',
        btnTexts: ['AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter4Advanced_btn'],
        img: ImgFilter4Advanced,
        keyStep: 'V2_FILTER4_ADVANCED'
      },
      {
        title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter5Advanced_label',
        description: 'AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter5Advanced_description',
        btnTexts: ['AdminHTML.DashboardV3.QuickStartGuideV2.Filter.Filter5Advanced_btn'],
        img: ImgFilter5Advanced,
        keyStep: 'V2_FILTER5_ADVANCED'
      }
    ]
  },
  {
    title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Search.Search_title',
    icon: IconSearch,
    keyGuide: 'V2_SEARCH',
    feature: 'Search',
    children: [
      {
        title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Search.Search1_label',
        description: 'AdminHTML.DashboardV3.QuickStartGuideV2.Search.Search1_description',
        btnTexts: ['AdminHTML.DashboardV3.QuickStartGuideV2.Search.Search1_btn'],
        img: ImgSearch1,
        keyStep: 'V2_SEARCH1'
      },
      {
        title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Search.Search2_label',
        description: 'AdminHTML.DashboardV3.QuickStartGuideV2.Search.Search2_description',
        btnTexts: ['AdminHTML.DashboardV3.QuickStartGuideV2.Search.Search2_btn'],
        img: ImgSearch2,
        keyStep: 'V2_SEARCH2'
      }
    ]
  },
  {
    title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Recommend.Recommend_title',
    icon: IconRecommend,
    keyGuide: 'V2_RECOMMEND',
    feature: 'Recommendation',
    children: [
      {
        title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Recommend.Recommend1_label',
        description: 'AdminHTML.DashboardV3.QuickStartGuideV2.Recommend.Recommend1_description',
        btnTexts: ['AdminHTML.DashboardV3.QuickStartGuideV2.Recommend.Recommend1_btn'],
        img: ImgRecommend1,
        keyStep: 'V2_RECOMMEND1'
      },
      {
        title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Recommend.Recommend2_label',
        description: 'AdminHTML.DashboardV3.QuickStartGuideV2.Recommend.Recommend2_description',
        btnTexts: ['AdminHTML.DashboardV3.QuickStartGuideV2.Recommend.Recommend2_btn'],
        img: ImgRecommend2,
        keyStep: 'V2_RECOMMEND2'
      }
    ]
  },
  {
    title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview_title',
    icon: IconPreview,
    keyGuide: 'V2_PREVIEW',
    feature: 'Preview',
    children: [
      {
        keyStep: 'V2_PREVIEW1',
        cases: [
          {
            // NOT_INSTALLED_ON_THEME: 0
            title:
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case0_not_installed_label',
            title_t:
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case0_not_installed_label_t',
            description:
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case0_not_installed_description',
            description_t:
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case0_not_installed_description_t',
            btnTexts: [
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case0_not_installed_btn'
            ],
            img: ImgPreview1
          },
          {
            // INSTALLED_ON_NOT_LIVE_THEME: 1,
            title:
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case1_not_on_live_label',
            title_t:
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case1_not_on_live_label_t',
            description:
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case1_not_on_live_description',
            btnTexts: [
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case1_not_on_live_btn'
            ],
            img: ImgPreview2
          },
          {
            // INSTALLED_ON_LIVE_THEME: 2,
            title: 'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case2_installed_label',
            title_t:
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case2_installed_label_t',
            description:
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case2_installed_description',
            btnTexts: [
              'AdminHTML.DashboardV3.QuickStartGuideV2.Preview.Preview1_case2_installed_btn'
            ],
            img: ImgPreview3
          }
        ]
      }
    ]
  }
];

export const STATUS_INSTALL_ON_THEME = {
  NOT_INSTALLED_ON_THEME: 0,
  INSTALLED_ON_NOT_LIVE_THEME: 1,
  INSTALLED_ON_LIVE_THEME: 2,
  SSR: 3
};
